import { render, staticRenderFns } from "./createImg.vue?vue&type=template&id=496c7b1d&scoped=true&"
import script from "./createImg.vue?vue&type=script&lang=js&"
export * from "./createImg.vue?vue&type=script&lang=js&"
import style0 from "./createImg.vue?vue&type=style&index=0&id=496c7b1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c7b1d",
  null
  
)

export default component.exports